/* Dropdown de tecido isolado para promoção cirúrgica no tema Live. */
(() => {
  const pdp = document.querySelector("[data-pdp]");
  if (!pdp || pdp.dataset.fabricDropdownReady === "true") return;
  pdp.dataset.fabricDropdownReady = "true";

  const closeDropdown = (dropdown, restoreFocus = false) => {
    if (!dropdown) return;
    const trigger = dropdown.querySelector("[data-fabric-dropdown-trigger]");
    const menu = dropdown.querySelector("[data-fabric-dropdown-menu]");
    dropdown.classList.remove("is-open");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (menu) menu.hidden = true;
    if (restoreFocus && trigger) trigger.focus();
  };

  const openDropdown = (dropdown) => {
    if (!dropdown) return;
    pdp.querySelectorAll("[data-fabric-dropdown].is-open").forEach((open) => {
      if (open !== dropdown) closeDropdown(open);
    });
    const trigger = dropdown.querySelector("[data-fabric-dropdown-trigger]");
    const menu = dropdown.querySelector("[data-fabric-dropdown-menu]");
    if (!trigger || !menu) return;
    menu.hidden = false;
    dropdown.classList.add("is-open");
    trigger.setAttribute("aria-expanded", "true");
  };

  pdp.addEventListener("click", (event) => {
    const trigger = event.target.closest && event.target.closest("[data-fabric-dropdown-trigger]");
    if (trigger && pdp.contains(trigger)) {
      const dropdown = trigger.closest("[data-fabric-dropdown]");
      if (!dropdown) return;
      if (dropdown.classList.contains("is-open")) closeDropdown(dropdown);
      else openDropdown(dropdown);
      return;
    }

    const current = event.target.closest && event.target.closest("[data-fabric-dropdown-current]");
    if (current && pdp.contains(current)) {
      closeDropdown(current.closest("[data-fabric-dropdown]"), true);
    }
  });

  pdp.addEventListener("keydown", (event) => {
    const dropdown = event.target.closest && event.target.closest("[data-fabric-dropdown]");
    if (!dropdown || !pdp.contains(dropdown)) return;
    const trigger = dropdown.querySelector("[data-fabric-dropdown-trigger]");

    if (event.key === "Escape" && dropdown.classList.contains("is-open")) {
      event.preventDefault();
      closeDropdown(dropdown, true);
      return;
    }

    if ((event.key === "ArrowDown" || event.key === "ArrowUp") && event.target === trigger) {
      event.preventDefault();
      openDropdown(dropdown);
      const options = Array.from(dropdown.querySelectorAll("[data-fabric-dropdown-option]"));
      const target = event.key === "ArrowUp" ? options[options.length - 1] : options[0];
      if (target) target.focus();
    }
  });

  document.addEventListener("click", (event) => {
    pdp.querySelectorAll("[data-fabric-dropdown].is-open").forEach((dropdown) => {
      if (!dropdown.contains(event.target)) closeDropdown(dropdown);
    });
  });

  document.addEventListener("focusin", (event) => {
    pdp.querySelectorAll("[data-fabric-dropdown].is-open").forEach((dropdown) => {
      if (!dropdown.contains(event.target)) closeDropdown(dropdown);
    });
  });
})();
